import Models from './Models';
import Value from './Value';

export default class Values extends Models {

    constructor(...models) {
        super(...models);
    }

}